import { createApp } from 'vue'
import ToastComponent from './index.vue'

let toastInstance = null

export function createToast(options) {
  if (toastInstance) {
    toastInstance.$remove()
  }

  const app = createApp(ToastComponent, options)
  const container = document.createElement('div')
  document.body.appendChild(container)

  toastInstance = app.mount(container)

  toastInstance.$remove = () => {
    app.unmount()
    document.body.removeChild(container)
    toastInstance = null
  }

  return toastInstance
}
